<template>
    <div>
        <div v-if="data.option.length > 0">
            <el-radio-group  class="single-option" v-model="data.value[0]">
                <el-radio :label="index" v-for="(item, index) in data.option">
                    <span class="sort-item">{{index + 1 | formatNumber}}</span>
                    <el-input v-model="item.name" placeholder="请输入内容" class="single-input"></el-input>
                    <i class="el-icon-close" @click.stop="del(index)"></i>
                </el-radio>
            </el-radio-group>
        </div>
        <el-button type="primary" size="small" @click="addOption">+ 添加选项</el-button>
    </div>
</template>

<script>
    export default {
        name: "SingleChoice",
        props: ['data'],
        filters: {
            // 试题答案格式
            formatNumber(nums) {
                const numbers = {
                    '1': 'A',
                    '2': 'B',
                    '3': 'C',
                    '4': 'D',
                    '5': 'E',
                    '6': 'F',
                }
                return numbers[nums]
            },
        },
        data() {
            return {

            }
        },
        mounted() {
        },
        methods: {
            //添加选项
            addOption() {
                let option = {
                    name: ''
                }
                if (this.data.option.length < 4) {
                    this.data.option.push(option);
                } else {
                    this.$message({
                        message: '最多只能添加四个选项！',
                        type: 'warning'
                    });
                }
                console.log('data', this.data)
            },
            del(index) {
                this.data.option.splice(index, 1);
            }
        }
    }
</script>

<style scoped lang="scss">
    .single-option {
        width: 100%;
        margin-bottom: 10px;
        .el-radio {
            display: block;
            margin-bottom: 12px;
            &:last-child {
                margin-bottom: 0;
            }
        }
        .single-input {
            width: 700px;
        }
    }
    .sort-item {
        margin-right: 15px;
    }
    .el-icon-close {
        color: #A0A0A0;
        margin-left: 12px;
    }
</style>